import axios from 'axios';
import { getConfig } from '../config';

const config = getConfig();

axios.interceptors.request.use(
  async (request) => {
    const token = getLocal('token');

    if (token) {
      request.headers.authorization = `Bearer ${token}`;
    }

    return request;
  }, (e) => {
    return Promise.reject(e);
  }
);

//Stars
export const STAR_COUNT = 6;

//Path
export const pathCategories = [
  { name: 'academic', label: 'Academic' },
  { name: 'financial', label: 'Financial' },
  { name: 'wellbeing', label: 'Wellbeing' },
  { name: 'career', label: 'Career' }
];
export const TILE_COUNT = 10;

//Profile
export const defaultProfile = [
  { param: 'name', category: 'profile', type: 'text', label: 'Name', prompt: 'What’s your name?' },
  { param: 'age', category: 'profile', type: 'text', label: 'Age', prompt: 'How old are you?' },
  { param: 'location', category: 'profile', type: 'text', label: 'Location', prompt: 'Where are you located?' },
  { param: 'status', category: 'academic', type: 'select', label: 'Academic Status', prompt: 'What is your academic status?', values: ['Not in School', 'High School', 'College', 'Job Training', 'Working', 'Military', 'Other'] },
  { param: 'school', category: 'academic', type: 'text', label: 'School', prompt: 'Where are you in school (high school, college, other)?' },
  { param: 'study', category: 'academic', type: 'text', label: 'Studying', prompt: 'What are you studying?' },
  { param: 'status_info', category: 'academic', type: 'text', label: 'Current Situation', prompt: 'Can you tell me more about your situation (your current school, job, etc)?' },
  { param: 'financial_needs', category: 'financial', type: 'text', label: 'Financial Aid Needs', prompt: 'What are your financial aid needs?' },
  { param: 'financial_application', category: 'financial', type: 'text', label: 'Completed Application', prompt: 'Have you completed the FAFSA or WAFSA application?' },
  { param: 'loans', category: 'financial', type: 'text', label: 'Student Loans', prompt: 'Are you applying for student loans?' },
  { param: 'interests', category: 'wellbeing', type: 'text', label: 'Interests', prompt: 'What are your interests or things that you love to do?' },
  { param: 'housing', category: 'wellbeing', type: 'text', label: 'Housing', prompt: 'Do you need to find housing?' },
  { param: 'goal', category: 'career', type: 'text', label: 'Your Goal', prompt: 'What is your goal?' },
  { param: 'goal_info', category: 'career', type: 'text', label: 'About Your Goals', prompt: 'Can you tell me more about your goals (career, life, other)?' }
];

//Local Storage
export const deleteLocal = (key) => {
  localStorage.removeItem(key);
};

export const emptyLocal = () => {
  localStorage.clear();
};

export const getLocal = (key) => {
  const v = localStorage.getItem(key);
  return v ? JSON.parse(v) : false;
};

export const setLocal = (key, val) => {
  localStorage.setItem(key, val ? JSON.stringify(val) : false);
};

//API calls
export const bookmarkMessage = async (id) => {
  try {
    const response = await sendAction('bookmark', id);

    if (response?._id) {
      return response._id;
    }

    return null;
  } catch (e) {
    throw new Error('An error occurred while creating bookmark');
  }
};

export const unbookmarkMessage = async (bookmarkActionId) => {
  try {
    const response = await deleteAction(bookmarkActionId);

    if (response !== null) {
      return true;
    }

    return false;
  } catch (e) {
    throw new Error('An error occurred while removing bookmark');
  }
};
export const checkTile = async (id) => {
  try {
    const response = await sendAction('check', id);

    if (response?._id) {
      return response._id;
    }

    return null;
  } catch (e) {
    throw new Error('An error occurred while checking tile');
  }
};

export const uncheckTile = async (checkActionId) => {
  try {
    const response = await deleteAction(checkActionId);

    if (response !== null) {
      return true;
    }

    return false;
  } catch (e) {
    throw new Error('An error occurred while unchecking tile');
  }
};

export const getActions = async (category) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API}/api/actions?category=${category}`);

    if (response?.data?.length) {
      return response.data;
    }

    return [];
  } catch (e) {
    throw new Error('An error occurred while getting actions');
  }
};

export const sendAction = async (category, messageId = null, metaData = null) => {
  try {
    const data = {
      category
    };

    if (messageId) {
      data.messageIds = [messageId];
    }

    if (metaData) {
      data.meta_data = metaData;
    }

    const response = await axios.post(`${process.env.REACT_APP_API}/api/actions`, data);

    if (response?.data?._id) {
      return response.data;
    }

    return null;
  } catch (e) {
    throw new Error('An error occurred while sending action');
  }
};

export const deleteAction = async (id) => {
  try {
    const response = await axios.delete(`${process.env.REACT_APP_API}/api/actions/${id}`);

    if (response?.data?.action?._id) {
      return response.data.action._id;
    }

    return null;
  } catch (e) {
    throw new Error('An error occurred while deleting action');
  }
};

export const getChatMessages = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API}/api/messages?category=question`);

    if (response?.data?.length) {
      setLocal('messageCount', response.data.length);

      return response?.data.map(message => {
        return {
          ...message,
          bookmarkActionId: message.actions?.find(a => a.category === 'bookmark')?._id
        };
      });
    } else {
      setLocal('messageCount', 0);
    }

    return [];
  } catch (e) {
    throw new Error('An error occurred while getting chat');
  }
};

export const getMessage = async (id) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API}/api/messages/${id}`);

    if (response?.data?._id) {
      return JSON.parse(response.data.response);
    }

    return null;
  } catch (e) {
    throw new Error('An error occurred while getting message');
  }
};

export const getPathData = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API}/api/messages?category=tiles`);

    if (response?.data?.length) {
      return response.data.map(tile => {
        return {
          ...JSON.parse(tile.response),
          _id: tile._id,
          checkActionId: tile.actions?.find(a => a.category === 'check')?._id
        };
      });
    }

    return [];
  } catch (e) {
    throw new Error('An error occurred while getting path data');
  }
};

export const createStarMessages = async (count) => {
  try {
    const data = {
      category: 'stars',
      message: `Please give me ${count} items`
    };

    const response = await axios.post(`${process.env.REACT_APP_API}/api/messages`, data);

    if (response?.data?.messages?.length) {
      return response.data.messages.map(star => {
        return {
          ...JSON.parse(star.response),
          _id: star._id
        };
      });
    }
  } catch (e) {
    throw new Error('An error occurred while creating stars');
  }
};

export const createTileMessages = async (count) => {
  try {
    const data = {
      category: 'tiles',
      message: `Please give me ${count} items`
    };

    const response = await axios.post(`${process.env.REACT_APP_API}/api/messages`, data);

    if (response?.data?.messages?.length) {
      return response.data.messages.map(tile => {
        return {
          ...JSON.parse(tile.response),
          _id: tile._id
        };
      });
    }
  } catch (e) {
    throw new Error('An error occurred while creating path data');
  }
};

export const getStarMessages = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API}/api/messages?category=stars`);

    if (response?.data?.length) {
      return response.data.map(star => {
        return {
          ...JSON.parse(star.response),
          _id: star._id
        };
      });
    }

    return [];
  } catch (e) {
    throw new Error('An error occurred while getting stars');
  }
};

export const sendChatMessage = async (message, parentMessageId = null) => {
  try {
    const data = {
      category: 'question',
      message
    };

    if (parentMessageId) {
      data.parentMessageId = parentMessageId;
    }

    const response = await axios.post(`${process.env.REACT_APP_API}/api/messages`, data);

    if (response?.data?.messages?.length) {
      const messageCount = getLocal('messageCount');
      setLocal('messageCount', messageCount ? parseInt(messageCount, 10) + 1 : 1);

      return {
        message: response.data.messages[0],
        topics: response.data.messages[0].topics?.length ? response.data.messages[0].topics : []
      };
    }

    return null;
  } catch (e) {
    throw new Error('An error occurred while sending chat');
  }
};

export const postSlackMessage = async (message) => {
  try {
    const data = {
      message
    };

    await axios.post(`${process.env.REACT_APP_API}/api/external/slack`, data);

    return true;
  } catch (e) {
    throw new Error('An error occurred while sending feedback');
  }
};

export const forgetUser = async () => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API}/api/unlink-me`, null);

    return response.data;
  } catch (error) {
    console.error('Error in forgetUser:', error);
    const message = error.response?.data?.message || 'Failed to process deletion request.';
    throw new Error(message);
  }
};

export const resetProfile = async () => {
  try {
    emptyLocal();
    window.location = '/';

    return null;
  } catch (e) {
    throw new Error('An error occurred while resetting profile');
  }
};

export const syncProfile = async (email, phone) => {
  try {
    if (email || phone) {
      const data = {
        email,
        phone,
        meta_data: defaultProfile
      };

      const response = await axios.post(`${process.env.REACT_APP_API}/api/profile`, data);

      if (response?.data?._id) {
        setLocal('profile', response.data);

        return response;
      }
    }

    return null;
  } catch (e) {
    throw new Error('An error occurred while creating profile');
  }
};

export const updateProfileAsTester = async (isTester) => {
  try {
    const data = {
      isTester
    };

    const response = await axios.patch(`${process.env.REACT_APP_API}/api/profile`, data);

    if (response?.data?._id) {
      const newProfile = response.data;

      setLocal('profile', newProfile);

      return newProfile;
    }

    return null;
  } catch (e) {
    throw new Error('An error occurred while updating profile');
  }
};

export const updateProfile = async (param, value) => {
  try {
    if (param === 'name' && value?.length > 25) {
      window.alert('Please restrict your name to 25 characters');
      return null;
    }

    let profile = getLocal('profile');

    if (profile?._id) {
      if (!profile?.meta_data?.length) {
        profile.meta_data = [];
      }

      let paramIndex = profile.meta_data.findIndex(p => p.param === param);

      if (paramIndex >= 0) {
        profile.meta_data[paramIndex].value = value;
      } else {
        paramIndex = defaultProfile.findIndex(p => p.param === param);

        if (paramIndex >= 0) {
          profile.meta_data.push({
            ...defaultProfile[paramIndex],
            value: value
          });
        }
      }

      if (paramIndex >= 0) {
        const data = {
          email: profile.email,
          phone: profile.phone,
          meta_data: profile.meta_data
        };
  
        const response = await axios.patch(`${process.env.REACT_APP_API}/api/profile`, data);
  
        if (response?.data?._id) {
          const newProfile = response.data;
  
          setLocal('profile', newProfile);
  
          return newProfile;
        }
      }
    }

    return null;
  } catch (e) {
    throw new Error('An error occurred while updating profile');
  }
};

export const sendReferrals = async (emails) => {
  try {
    if (emails?.length) {
      const data = {
        emails
      };

      const response = await axios.post(`${process.env.REACT_APP_API}/api/referrals/send`, data);

      if (response?.status === 202) {
        return response.data;
      }
    }

    return null;
  } catch (e) {
    throw new Error('An error occurred while sending referrals');
  }
};

export const sendOTP = async (phone) => {
  try {
    const data = {
      client_id: config.clientId,
      connection: 'sms',
      phone_number: phone,
      send: 'code'
    };

    const response = await axios.post(`https://${config.domain}/passwordless/start`, data);

    if (response?.status === 200) {
      return response.data;
    }

    return null;
  } catch (e) {
    throw new Error('An error occurred while sending OTP');
  }
};